var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionswhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1966 1.66667L1.86328 5.83334L10.1966 10L18.5299 5.83334L10.1966 1.66667Z",
    stroke: "white",
    strokeWidth: 1.66667
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86328 14.1667L10.1966 18.3333L18.5299 14.1667",
    stroke: "white",
    strokeWidth: 1.66667
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86328 10L10.1966 14.1667L18.5299 10",
    stroke: "white",
    strokeWidth: 1.66667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionswhite);
export default __webpack_public_path__ + "static/media/transactionswhite.cc83154c6e388f936ab3a6f8d1b5f825.svg";
export { ForwardRef as ReactComponent };